const ROOTS = {
  host: {
    development: 'http://api-chat-test.youyisia.com',
    // development: 'http://api.mehiya.com',
    test: 'http://api-chat-test.youyisia.com',
    // production: 'http://api.higochat.net',
    production: 'http://api.in.higochat.net',
  }
}

const roots2Proxies = (env) =>
  Object.entries(ROOTS).map(([key, value]) => {
    return {
      match: `/${key}`,
      map: (path) => path.replace(`/${key}`, ''),
      host: value[env],
    }
  })
module.exports = {
  ROOTS,
  production: {
    ENV: 'production',
    staticServerIps: ['10.0.1.124','10.0.0.209'],
    staticServerHost: 'static.higochat.net',
    proxies: roots2Proxies('production'),
  },
  test: {
    ENV: 'test',
    staticServerIps: ['172.30.43.73'],
    staticServerHost: 'static-chat-test.youyisia.com',
    proxies: roots2Proxies('test'),
  },
  development: {
    ENV: 'development',
    proxies: roots2Proxies('development'),
  },
}
